"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteTitle = exports.useCachedServerConfig = void 0;
var react_1 = require("react");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var LS_SERVER_CONFIG_KEY = "tgcw:server:config";
var useCachedServerConfig = function () {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.server.config; }), isFetching = _a.isFetching, initialFetchDone = _a.initialFetchDone, fetchedServerConfig = _a.data;
    var _b = (0, react_1.useState)(false), storedThisSession = _b[0], setStoredThisSession = _b[1];
    var serverConfig = (0, react_1.useMemo)(function () {
        if (!storedThisSession) {
            return (0, utils_1.getLocalStorageJSON)(LS_SERVER_CONFIG_KEY);
        }
        else {
            return fetchedServerConfig;
        }
    }, [storedThisSession]);
    (0, react_1.useEffect)(function () {
        if (fetchedServerConfig && Object.keys(fetchedServerConfig).length) {
            (0, utils_1.setLocalStorageJSON)(LS_SERVER_CONFIG_KEY, fetchedServerConfig);
            setStoredThisSession(true);
        }
    }, [fetchedServerConfig]);
    return { isFetching: isFetching, initialFetchDone: initialFetchDone, config: serverConfig };
};
exports.useCachedServerConfig = useCachedServerConfig;
var useSiteTitle = function () {
    var _a = (0, exports.useCachedServerConfig)(), initialFetchDone = _a.initialFetchDone, config = _a.config;
    return (0, react_1.useMemo)(function () {
        if ("APP_NAME" in config) {
            return config.APP_NAME;
        }
        else {
            return initialFetchDone ? "Trail Guide" : "";
        }
    }, [initialFetchDone, config]);
};
exports.useSiteTitle = useSiteTitle;
